import {
    INITIATE_CALL,
    CREATE_CALL,
    RECEIVE_CALL,
    ANSWER_CALL,
    ANSWER_CALL_RECEIVED,
    CLOSE_CALL,
    RECEIVE_ACKNOWLEDGE,
    CALL_ACKNOWLEDGE,
    CALL_DATA,
    CALL_POPUP,
    SEND_ICE_CANDIDATE,
    RECEIVE_ICE_CANDIDATE,
    END_CALL,
    CLEAR_CALL,
    SET_VICI_SESSION,
    CLEAR_VICI_SESSION,
    VICI_ACKNOWLEDGE,
    RECEIVE_VICI_ACKNOWLEDGE,
} from 'App/store/constants';

export const updateCallPopup = (data: any) => ({
    type: CALL_POPUP,
    payload: data,
});

export const updateCallData = (data: any) => ({
    type: CALL_DATA,
    payload: data,
});

export const setInitiateCall = () => ({
    type: INITIATE_CALL,
});

export const setCreateCallOffer = (data: any) => ({
    type: CREATE_CALL,
    payload: data,
});

export const setReceiveCallOffer = (data: any) => ({
    type: RECEIVE_CALL,
    payload: data,
});

export const sendIceCandidate = (data: any) => ({
    type: SEND_ICE_CANDIDATE,
    payload: data,
});

export const setReceiveIceCandidate = (data: any) => ({
    type: RECEIVE_ICE_CANDIDATE,
    payload: data,
});

export const setAnswerCall = (data: any) => ({
    type: ANSWER_CALL,
    payload: data,
});

export const setAnswerReceivedCall = (data: any) => ({
    type: ANSWER_CALL_RECEIVED,
    payload: data,
});

export const receiveAcknowledge = () => ({
    type: RECEIVE_ACKNOWLEDGE,
    payload: '',
});

export const setCloseCall = () => ({
    type: CLOSE_CALL,
});

export const setEndCall = () => ({
    type: END_CALL,
});

export const setAcknowledgement = () => ({
    type: CALL_ACKNOWLEDGE,
});

export const setClearCall = () => ({
    type: CLEAR_CALL,
});

export const setViciSession = (data: any) => ({
    type: SET_VICI_SESSION,
    payload: data,
});

export const clearViciSessionState = () => ({
    type: CLEAR_VICI_SESSION,
});

export const setViciAcknowledge = (data: any) => ({
    type: VICI_ACKNOWLEDGE,
    payload: data,
});

export const receiveViciAcknowledge = (data: any) => ({
    type: RECEIVE_VICI_ACKNOWLEDGE,
    payload: data,
});
